import React from 'react'
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Modal } from "@mui/material";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "whitesmoke",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "auto" /* Enable vertical scrolling */,
    maxHeight: "100vh" /* Set a maximum height to limit scrolling */,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export const UserModal = (props) => {
  const columns = [
    { field: "firstName", headerName: "First Name", width: 100 },
    { field: "lastName", headerName: "Last Name", width: 100 },
    { field: "userName", headerName: "User Name", width: 200 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "isActivated", headerName: "Status", width: 100,
      renderCell: (params) =>{
        if (params.row.isActivated)
          return (
            <div style={{ fontFace: "bold", color: "#193A6F" }}>Active</div>
          );
        else return <div style={{ fontFace: "bold", color: "red" }}>Inactive</div>;
      }
    },
    { field: "createdDate", headerName: "Creation Date", width: 200,
      renderCell: (params) => {
        const date = new Date(
          new Date(params.value).getTime() -
            new Date(params.value).getTimezoneOffset() * 60000
        );
        return date.toLocaleDateString();
      },
    },
  ];

  const handleModalClose = () => {
    props.setOpen(false);
  };
  const classes = useStyles();
  return (
    <Modal
      className={classes.modal}
      open={props.isOpen}
      onClose={handleModalClose}
    >
      <div className={classes.paper}>
        <h3>List of Organization Account Users</h3>
        <DataGrid
          rows={props.users}
          // rows={organizations}
          columns={columns}
          pageSize={5}
          components={{
            Toolbar: GridToolbar,
          }}
          disableSelectionOnClick
          autoHeight
          disableColumnMenu
          disableColumnSelector
          getRowId={(row) => row.email}
        />
      </div>
    </Modal>
  );
}
